import { FlaskScale } from './flask/flask.model'

export const MIN = 0
export const MAX = 25_000_000

/**
 * The flask bar is non-linear on purpose: most users need less than R$ 2 milhões,
 * so R$ 0–R$ 2M fills the bottom 75% of the bar in fine R$ 100 mil steps, while
 * R$ 2M–R$ 25M is compressed into the top 25% in coarse R$ 1 milhão steps.
 */
export const FLASK_SCALE: FlaskScale = {
  min: MIN,
  max: MAX,
  breakpoint: 2_000_000,
  splitPct: 75,
  stepLow: 100_000,
  stepHigh: 1_000_000
}

export const LTV_RATIO = 0.6
export const computePropertyValue = (need: number) => Math.round(need / LTV_RATIO)

export const ANALYTICS_CATEGORY = 'Clique'
export const ANALYTICS_ACTION = 'Crédito ideal'
